import { Component, OnInit, Output, EventEmitter, ViewChild } from '@angular/core';
import { PlatformApiService, ResultFilter, Results } from '../../services/platform-api.service';
import { Plan } from '../../models/AccountModel';
import { DataTableComponent } from 'src/app/shared/tile-data-table/tile-data-table.component';
import { MatDialog } from '@angular/material/dialog';
import { ConfirmationComponent } from 'src/app/shared/confirmation.component';

@Component({
  selector: 'cw-ci-admin-plan-list',
  templateUrl: './plan-list.component.html',
  styleUrls: []
})
export class PlanListComponent implements OnInit {

  @Output() stateChange: EventEmitter<any> = new EventEmitter();
  @ViewChild(DataTableComponent, { static: true }) plansDataTable: DataTableComponent;
  plansList: Results;

  constructor(private _platformApi: PlatformApiService, public dialog: MatDialog) { }

  ngOnInit() {

  }

  isSelectable(item: Plan) {
    return true;
  }

  addPlan(event?) {
    this.stateChange.emit({ state: 'CREATE' });
  }

  editPlan(item: Plan) {
    this.stateChange.emit({ state: 'EDIT', item });
  }

  deletePlan(item: Plan) {
    const pMessage = item.isActive ? 'Are you sure you want to deactivate this plan?' : 'Are you sure you want to permanently delete this plan?';
    const statusMsg = item.isActive ? 'Deactivating plan...' : 'Deleting plan...';

    const dialogRef = this.dialog.open(ConfirmationComponent, {
      panelClass: 'flush-dialog',
      data: {
        promptMessage: [pMessage],
        closeLabel: 'No',
        buttons: [{label:'Yes', value:'YES', color:'primary'}],
        height: 'auto'
      }
    });
    dialogRef.afterClosed().subscribe(confirm => {
      if (confirm == 'YES') {
        this.plansDataTable.showProcessing(statusMsg);

        this._platformApi.deletePlan(item.id).subscribe(
          resp => {
            this.plansDataTable.executeLoadItems();
          }
        );
      }
    });
  }

  loadPlans(filter = new ResultFilter()) {
    this.plansDataTable.showProcessing();
    const listObservable = this._platformApi.getPlans(filter);
    listObservable.subscribe(results => {
      this.plansList = results;
    })
  }
}
